import React, { useState, useContext, useCallback, useEffect } from "react"
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import { useParams, useNavigate } from "react-router-dom"
import { Dropdown } from 'primereact/dropdown'
import styles from "../../styles/Telerecovery.module.css"

import TRSMSIndex from "./SMS/TRSMSIndex"
import TRVideoIndex from "./Video/TRVideoIndex"
import TRAudioIndex from "./Audio/TRAudioIndex"
import ROUTES from "../../components/Routes/routesContants"
import { UserContext } from "../../context/userContext"
import { PARTICIPANT_BLOCK } from "../Participant/ParticipantProfile/queries"
import { useQuery } from "@apollo/client"
import { LoaderMedium } from "../../components/Loaders"
import { trApiFindStaffNumber } from "./telerecoveryApi"
import TRChatMessagesIndex from "./Chat Messages/TRChatMessagesIndex"
import ParticipantProfileBoxSmall from "../../components/ParticipantProfileBoxSmall"

export default function TelerecoveryServices() {
  const { type } = useParams()

  const [selectedType, setSelectedType] = useState(type)
  const navigate = useNavigate()
  const [staffPhoneNumber, setStaffPhoneNumber] = useState(null)
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [loadingStaffNumber, setLoadingStaffNumber] = useState(null)

  const [isOkaytoText, setIsOkaytoText] = useState(null)
  const [isOkaytoContactByPhone, setIsOkaytoContactByPhone] = useState(null)

  const { loading } = useQuery(PARTICIPANT_BLOCK, {
    fetchPolicy: "network-only",
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: user.organization_id,
      enterprise_id: user.enterprise_id,
      idBlock: "participant__contact_information",
    },
    enabled: userCtx.participant_id,
    onError: (e) => console.log(e),
    onCompleted: (data) => {
      if (data && data.blockSaved && data.blockSaved.data) {
        const parsedData = JSON.parse(data.blockSaved.data)
        if (
          parsedData &&
          parsedData.values.participant_phone_primary_preference.find(
            (s) => s === "Okay to contact via phone"
          )
        ) {
          setIsOkaytoContactByPhone(true)
        } else {
          setIsOkaytoContactByPhone(false)
        }
        if (
          parsedData &&
          parsedData.values.participant_phone_primary_preference.find(
            (s) => s === "Okay to text"
          )
        ) {
          setIsOkaytoText(true)
        } else {
          setIsOkaytoText(false)
        }
      }
    },
  })

  const findStaffNumber = useCallback(() => {
    setLoadingStaffNumber(true)
    trApiFindStaffNumber(
      userCtx.tokenTelerecovery,
      user.staff_id,
      user.organization_id,
      user.organization_alias,
      user.staff_alias
    ).then(
      (response) => {
        if (response.phoneNumber) {
          setStaffPhoneNumber(response.phoneNumber)
        }
        setLoadingStaffNumber(false)
      },
      (err) => {
        console.log(err)
        setLoadingStaffNumber(false)
      }
    )
  }, [user.organization_id, user.staff_id, userCtx.tokenTelerecovery])

  useEffect(() => {
    setSelectedType(type)
  }, [type])

  useEffect(() => {
    findStaffNumber()
  }, [findStaffNumber])

  const updateUrlParam = (trType) => {
    return navigate(ROUTES.PARTICIPANT_TELERECOVERY_SERVICES + "/" + trType)
  }

  //could move this to another component if i use redux
  const SideBar = () => {
    const items = [
      {
        label: "Video Sessions",
        value: "video"
      },
      {
        label: "Audio Sessions",
        value: "audio"
      },
      {
        label: "SMS Messages",
        value: "sms"
      },
      {
        label: "Chat Messages",
        value: "chat"
      },
    ]

    return (
      <div className={styles.index}>
        <div>
          {userCtx.participant_id && (
            <h2>
              Telerecovery with:{" "}
              {userCtx.participant_name_first +
                " " +
                userCtx.participant_name_last}
            </h2>
          )}
        </div>
        <Dropdown
          value={selectedType}
          className="custom_dropdown_primary"
          style={{ width: "200px" }}
          panelClassName="custom_dropdown_panel_primary"
          options={items}
          onChange={(e) => {
            setSelectedType(e.value)
            updateUrlParam(e.value)
          }}
          optionLabel="label"
          optionValue="value"
        />
      </div>
    )
  }

  if (loading || !userCtx.participant_id) {
    return <LoaderMedium></LoaderMedium>
  }

  return (
    <div>
      <h1>Participant Profile</h1>

      <div className="layout-with-sidebar">
        <div className="sidebar">
          <ParticipantSidebar />
        </div>
        <div className="main-content">
          <ParticipantProfileBoxSmall />
          <SideBar />
          <div style={{ maxWidth: "800px", minHeight: "500px" }}>
            {!staffPhoneNumber && !loadingStaffNumber && (
              <span
                style={{
                  marginTop: "50px",
                  textAlign: "center",
                  fontSize: "18px",
                  display: "block",
                }}
              >
                You do not have a telerecovery number assigned. Please contact
                an administrator.
              </span>
            )}
            {selectedType === "audio" &&
              userCtx.participant_id &&
              staffPhoneNumber && (
                <TRAudioIndex
                  staffNumber={staffPhoneNumber}
                  isOkaytoContactByPhone={isOkaytoContactByPhone}
                ></TRAudioIndex>
              )}
            {selectedType === "video" &&
              userCtx.participant_id &&
              staffPhoneNumber && (
                <TRVideoIndex></TRVideoIndex>
              )}
            {selectedType === "sms" &&
              userCtx.participant_id &&
              staffPhoneNumber && (
                <TRSMSIndex
                  isOkayToText={isOkaytoText}
                  staffPhoneNumber={staffPhoneNumber}
                />
              )}
            {selectedType === "chat" &&
              userCtx.participant_id &&
              staffPhoneNumber && <TRChatMessagesIndex />}
          </div>
        </div>
      </div>

    </div>
  )
}
